import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import { RootStore } from "./rootStore";

export default class ResponsiveStore {
  rootStore: RootStore;
  isMobileMediaQuery:boolean=false;
  showHomeModal: boolean = false;
  isColorModalOpen: boolean= false;
  isSidebarModalOpen: boolean= false;

  setIsSidebarModalOpen = (showSidebar:boolean) =>{
    this.isSidebarModalOpen = showSidebar;
  }

  setColorModalOpen = (showColorModal:boolean) =>{
    this.isColorModalOpen = showColorModal;
  }

  setHomeModalOpen = (showHome:boolean) =>{
    this.showHomeModal = showHome;
  }


  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
  
  
   setIsMobileMediaQuery = (isMobile:boolean) =>{
    this.isMobileMediaQuery = isMobile;
  };

}